/* eslint-disable react/display-name */
import {
  Chart as ChartJS,
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  DoughnutController,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  Title,
  Tooltip,
} from "chart.js";
import "chartjs-adapter-date-fns";
import { Fade } from "@mui/material";

ChartJS.register(
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  DoughnutController,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  Title,
  Tooltip
);
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { SnackbarProvider } from "notistack";
import { QueryClientProvider } from "react-query";
import { Layout } from "./src/components/Layout";
import SnackbarInAxios from "./src/components/snackbar-in-axios";
import { queryClient } from "./src/utils/react-query-util";
import { ThemeProvider } from "@wealthx/ui/theme";
import {
  TenantThemeProvider,
  useTenantTheme,
} from "./src/context/tenant-theme-context";

// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  window.analytics &&
    window.analytics.page(location.href, {
      path: location.pathname,
      url: location.href,
      referrer: prevLocation ? prevLocation.href : null,
    });
};

const TenantThemedApp = ({ children }) => {
  const { colors } = useTenantTheme();
  return (
    <ThemeProvider primary={colors.primary} secondary={colors.secondary}>
      {children}
    </ThemeProvider>
  );
};

export const wrapRootElement = ({ element }) => {
  return (
    <QueryClientProvider client={queryClient} contextSharing>
      <TenantThemeProvider>
        <TenantThemedApp>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SnackbarProvider
              maxSnack={1}
              preventDuplicate
              anchorOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              TransitionComponent={Fade}
            >
              <SnackbarInAxios>{element}</SnackbarInAxios>
            </SnackbarProvider>
          </LocalizationProvider>
        </TenantThemedApp>
      </TenantThemeProvider>
    </QueryClientProvider>
  );
};
